import React from 'react';
import classNames from 'classnames';
import FeatureFlag from 'client/components/FeatureFlag/FeatureFlag.react';
import {Badge} from '@albert-io/atomic';
import sessionStore from 'client/Session/SessionStore';

interface NotificationBadgeProps {
  className?: string;
}

const NotificationBadge = ({className}: NotificationBadgeProps) => {
  const isTeacher = sessionStore.isTeacher();

  if (!isTeacher) {
    return null;
  }

  const storedDate = localStorage.getItem('teacher_talk_notification_date_last_clicked');
  const envDate = process.env.TEACHER_TALK_NOTIFICATION_DATE;

  if (!envDate) {
    return null;
  }

  if (storedDate && envDate && storedDate >= envDate) {
    return null;
  }

  return (
    <FeatureFlag name='teacher_talk_notification_badge'>
      <Badge
        status='negative'
        size='small'
        emphasis='bold'
        className={classNames('absolute!', className)}
        icon={['fas', 'asterisk']}
      />
    </FeatureFlag>
  );
};

export default NotificationBadge;
